import { Pipe, PipeTransform } from '@angular/core';
import { Supplier } from '../../classes/supplier';

@Pipe({
  name: 'supplierNameFilter',
  pure: false
})
export class SupplierNameFilterPipe implements PipeTransform {

  transform(supplierList: Array<Supplier>, filterValue: string): any {
    if (!supplierList || !filterValue) {
      return supplierList;
    }
    const normalizedFilterValue = filterValue.toLowerCase().trim();
    return supplierList.filter(supplier =>
      (supplier.Name || '').toLowerCase().indexOf(normalizedFilterValue) !== -1
    );
  }

}
